import React from "react";

export const OtherServices = (props) => {
  return (
    <section className="container h-100 mb-5">
      <div className="col-lg-12 mt-5">
        <h1 className="other-services-title">Other Services</h1>
      </div>

      <div className="col-lg-12 mt-5">
        <div className="row">
          <div className="col-lg-6">
            <h2 className="othertitle">
              <span>01</span> Digital Marketing and Design
            </h2>
            <p>
              <ul>
                <li>Search engine optimization </li>
                <li>Content marketing</li>
                <li>Social media marketing</li>
                <li>Pay-per-click marketing</li>
                <li>Affiliate marketing</li>
                <li>Native advertising</li>
                <li>Influencer marketing</li>
                <li>Marketing automation</li>
                <li>Email marketing</li>
                <li>Mobile maketing</li>
              </ul>
            </p>
          </div>

          <div className="col-lg-6 ">
            <h2 className="othertitle">
              <span>02</span> Business Intelligence
            </h2>
            <h3 className="mx-2">
              <span className="mx-1">Power BI</span>
              <svg
                width={30}
                height={40}
                fill="#fff"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                {...props}
              >
                <path
                  fill="#ffff00"
                  d="M11.1 27.3c0 1.1-.9 2.1-2.1 2.1s-2.1-.9-2.1-2.1v-9c0-1.1.9-2.1 2.1-2.1s2.1.9 2.1 2.1zm6 2.4c0 1.1-.9 2.1-2.1 2.1s-2-.9-2-2.1V16c0-1.1.9-2.1 2.1-2.1s2.1.9 2.1 2.1v13.7zM5 25.3c0 1.1-.9 2.1-2.1 2.1S.8 26.5.8 25.3v-4.9c0-1.1.9-2.1 2.1-2.1s2.1 1 2.1 2.1zm18.1 6.6c0 1.1-.9 2.1-2.1 2.1-1.1 0-2-1-2-2.1V13.7c0-1.1.9-2.1 2.1-2.1 1.1 0 2.1.9 2.1 2.1v18.2z"
                />
                <path d="M29.7 31c-.4 0-.7-.1-1.1-.2l-2.5-.8c-.4-.1-.7-.6-.5-1 .1-.4.6-.7 1-.5l2.6.8c.5.2 1.1.1 1.6-.3.5-.3.7-.9.7-1.4V10.9c0-.8-.5-1.5-1.2-1.7L5.8 1.8c-.5-.2-1.1-.1-1.6.2-.4.4-.7.9-.7 1.5V15c0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8V3.5c0-1.1.5-2.1 1.4-2.7.9-.7 2-.8 3-.5l24.4 7.4c1.4.4 2.4 1.8 2.4 3.3v16.7c0 1.1-.5 2.1-1.4 2.8-.6.2-1.3.5-2 .5" />
              </svg>
            </h3>
            <p>
              What do we do in PowerBI? We can provide robust, interactive
              business reports, KPI records, and highly flexible dashboards. We
              can also provide a Business intelligent integrated data platform
              in your system for importing and transforming data.
            </p>

            <h3 className="mx-2">
              <span className="mx-1 ">OutSystems Integration</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={100}
                height={50}
                viewBox="0 0 400 100"
                {...props}
              >
                <path
                  d="M33.292 51.625a13.691 13.691 0 0027.239 0 12.278 12.278 0 00.066-1.4 13.685 13.685 0 10-27.369 0 12.755 12.755 0 00.064 1.4M10 50a36.913 36.913 0 1136.912 36.912A36.916 36.916 0 0110 50"
                  fill="#ff2400"
                />
                <path
                  d="M129.242 49.75c0 11.222-7.772 16.123-15.112 16.123-8.219 0-14.55-6.015-14.55-15.611 0-10.159 6.645-16.123 15.048-16.123 8.717 0 14.614 6.331 14.614 15.611m-24.078.316c0 6.646 3.827 11.666 9.214 11.666 5.27 0 9.216-4.956 9.216-11.8 0-5.138-2.57-11.665-9.1-11.665s-9.333 6.029-9.333 11.8M161.607 56.907c0 3.134.066 5.9.248 8.285h-4.888l-.314-4.955h-.132a11.414 11.414 0 01-10.041 5.65c-4.772 0-10.473-2.635-10.473-13.291V34.821h5.518v16.817c0 5.768 1.756 9.66 6.778 9.66a7.754 7.754 0 007.772-7.838V34.821h5.519v22.086zM189.906 59.542a14.463 14.463 0 007.276 2.19c4.011 0 5.9-2.006 5.9-4.51 0-2.634-1.573-4.076-5.65-5.583-5.452-1.94-8.021-4.956-8.021-8.587 0-4.889 3.944-8.9 10.473-8.9a15.1 15.1 0 017.459 1.887l-1.378 4.012a11.857 11.857 0 00-6.215-1.751c-3.263 0-5.085 1.887-5.085 4.142 0 2.5 1.822 3.644 5.768 5.138 5.268 2 7.969 4.64 7.969 9.163 0 5.335-4.142 9.161-11.352 9.161a17.287 17.287 0 01-8.533-2.135zM243.846 59.542a14.5 14.5 0 007.275 2.19c4.011 0 5.9-2.006 5.9-4.51 0-2.634-1.572-4.076-5.65-5.583-5.451-1.94-8.021-4.956-8.021-8.587 0-4.889 3.945-8.9 10.473-8.9a15.089 15.089 0 017.458 1.887l-1.381 4.012a11.865 11.865 0 00-6.215-1.756c-3.263 0-5.084 1.887-5.084 4.142 0 2.5 1.821 3.644 5.767 5.138 5.269 2 7.969 4.64 7.969 9.163 0 5.335-4.142 9.161-11.352 9.161a17.29 17.29 0 01-8.533-2.135zM320.029 43.039c0-3.133-.065-5.7-.248-8.217h4.819l.248 4.888h.185a10.451 10.451 0 019.529-5.584 8.954 8.954 0 018.587 6.083h.13a12.537 12.537 0 013.381-3.946 10.388 10.388 0 016.712-2.137c4.011 0 9.976 2.636 9.976 13.174v17.879h-5.387V47.994c0-5.832-2.138-9.345-6.582-9.345a7.153 7.153 0 00-6.527 5.02 9.136 9.136 0 00-.433 2.766v18.757h-5.387V47c0-4.823-2.137-8.336-6.331-8.336-3.447 0-5.965 2.766-6.842 5.517a7.579 7.579 0 00-.433 2.7v18.311h-5.388V43.039zM371.5 59.542a14.5 14.5 0 007.276 2.19c4.009 0 5.9-2.006 5.9-4.51 0-2.634-1.571-4.076-5.649-5.583-5.452-1.94-8.023-4.956-8.023-8.587 0-4.889 3.946-8.9 10.475-8.9a15.089 15.089 0 017.458 1.887l-1.377 4.012a11.857 11.857 0 00-6.213-1.756c-3.264 0-5.085 1.887-5.085 4.142 0 2.5 1.821 3.644 5.767 5.138 5.27 2 7.97 4.64 7.97 9.163 0 5.335-4.144 9.161-11.352 9.161a17.284 17.284 0 01-8.533-2.135zM234.041 34.742l-6.016 17.8c-.747 2.189-1.378 4.745-1.94 6.318h-.132c-.5-1.573-1.257-4.195-1.94-6.2l-6.645-17.918h-6.018l11.222 28.012a5.082 5.082 0 01.38 1.468 4.018 4.018 0 01-.433 1.325 16.824 16.824 0 01-4.64 6.147 14.793 14.793 0 01-4.824 2.7l1.494 4.614a15.044 15.044 0 006.647-3.552c3.762-3.264 6.462-8.639 10.407-19.046l8.284-21.681h-5.846zM313 51a19.973 19.973 0 00.183-2.583c0-5.6-2.635-14.339-12.571-14.339-8.861 0-14.274 7.236-14.274 16.411s5.6 15.4 14.956 15.4a23.167 23.167 0 0010.014-2.19l-1.375-4.207c-4.627 1.887-8.089 2.254-10.671 1.77a10.636 10.636 0 01-3-1.127c-4.09-2.5-4.589-7.8-4.641-8.926 0-.079-.012-.211-.012-.211zm-12.82-12.924c6.226 0 7.733 5.453 7.668 8.992H291.69c.445-3.539 2.9-8.992 8.494-8.992M183.1 59.6a7.21 7.21 0 01-3.422 1.363c-1.913-.026-3.21-1.35-3.21-5.06V38.806h7.863v-3.932h-7.863V24.06l-5.768 4.115v27.409c0 3.579.734 6.266 2.307 7.9a6.932 6.932 0 003.185 1.966 8.879 8.879 0 008.272-1.652zM281.676 59.6a7.21 7.21 0 01-3.422 1.363c-1.914-.026-3.212-1.35-3.212-5.06V38.806h7.865v-3.932h-7.865V24.06l-5.767 4.115v27.409c0 3.579.734 6.266 2.307 7.9a6.927 6.927 0 003.185 1.966 8.879 8.879 0 008.272-1.652z"
                  fill="#fff"
                />
              </svg>
            </h3>
            <p>
              We can create applications and portals for consumers. Build apps
              and portals for your modern workforce. Develop custom software
              that runs your business.
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-12 morewecando">
        <div className="row">
          <div className="">
            <h3 className="othertitle">What More We Can Do <span className="question-mark">?</span></h3>
            <div className="whatmore">
              <ol>
                <li> Microsoft Dynamic 365</li>
                <li>Google Workspace</li>
                <li>Self Managed Email Servers</li>
                <li>Microsoft Active Directory Hosting</li>
                <li>Database Management and Optimization</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
